import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '../../../components/special/LanguageProvider';
import { apiPostCall } from '../../../components/special/apiCall';
import { isResultOk, apiGetCall } from '../../../components/special/apiCall';
import { useErrorContext } from '../../../components/messages/ErrorBox';
import  InputDropDownList from 'components/input/InputDropDownList';
import InputAmount from '../../../components/input/InputAmount';
import { useToasts } from 'react-toast-notifications';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const SettingCostTransactionKey = ({ definition, transactionKeyList }) => {   
    const [settingValue, setSettingValue] = useState(JSON.parse(definition.value));    
    const [oldValue, setOldValue] = useState(definition.value);        
    
    const { t } = useLocale();
    const { addToast } = useToasts();
    
    const updateSetting = (jsonValue) =>{
        apiPostCall(BASE_URL + '/admin/setting/save', {...definition, value : jsonValue}).then(res => {                      
            setOldValue(jsonValue)            
            if (res && res.error){
                addToast(res.error.message, { appearance: 'error', autoDismiss : false })
            }
            else{                
                addToast(t('Breyting fyrir "') + t(definition.name) +t('" vistuð.'), { appearance: 'success' , autoDismiss : true })
            }            
        });        
    }

    const onUpdateTransactionKeyValue = (value) => {
        let jsonValue = JSON.stringify(value);        
        if (jsonValue.localeCompare(oldValue) !== 0){            
            setSettingValue(value);
            updateSetting(jsonValue);
        }
    }

    const onExit = () =>{
        let jsonValue = JSON.stringify(settingValue);        
        if (jsonValue.localeCompare(oldValue) !== 0){            
            updateSetting(jsonValue);
        }
    }

    return (       
        <div className="table-wrap form">
            <table className="table">
                <colgroup>
                    <col/>
                    <col width="150px"/>
                    <col />
                </colgroup>
            <thead>
            </thead>
            <tbody>                  
                <tr>
                    <td className="no-border"><div className="form">{t(definition.name)}</div></td>       
                    <td className="no-border"><InputAmount value={settingValue.Amount} onBlur={onExit} onChange={(value) => setSettingValue({...settingValue, Amount: value})}/></td>       
                    <td className="no-border"><InputDropDownList                          
                          list={transactionKeyList}
                          keyField="itemID"
                          displayField = { (item) => { return item.name + " " + (item.data ? "("+item.data.key+")" : ""); } }
                          defaultValue = {settingValue.TransactionKeyID}
                          onChange={(value) => onUpdateTransactionKeyValue({...settingValue, TransactionKeyID: (value ? Number(value) : null)})}                          
                          nullable={true}
                          nullableItem={ {itemID : null, name : ""} }/></td>       
                </tr>
            </tbody>
            </table>
        </div>   
      );
};


export default SettingCostTransactionKey;
